/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as roomActions from '../actions/roomActions';

export function useParticipants(roomId: string) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  async function dispatchParticipants() {
    try {
      await roomActions.fetchParticipants(roomId)(dispatch);
      setIsLoading(false);
    } catch {
      roomActions.setRoomError({ hasError: true, message: 'Please try again later' });
      setIsLoading(false);
    }
  }

  function resetParticipants() {
    return roomActions.resetParticipants()(dispatch);
  }

  return { isLoading, dispatchParticipants, resetParticipants };
}
